import { render, staticRenderFns } from "./adicionalesNotaMedica.vue?vue&type=template&id=7678871b&scoped=true"
import script from "./adicionalesNotaMedica.vue?vue&type=script&lang=js"
export * from "./adicionalesNotaMedica.vue?vue&type=script&lang=js"
import style0 from "./adicionalesNotaMedica.vue?vue&type=style&index=0&id=7678871b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678871b",
  null
  
)

export default component.exports